export { default as Sticker } from './ProductBlockSticker'
export { default as StickerLeft } from './ProductBlockStickerLeft'
